import type { Product } from '../core/types/catalog'
import { policyCopy } from './policies'

/** Uit de instellingen (cadeaubon geldig), zodat bon en uitleg nooit uiteenlopen. */
const VALIDITY = policyCopy.giftCardValidity

const IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/f7cf3984-bb1e-4d69-ac92-ebab86218044.jpg'
const NOTE = 'Te besteden aan producten én behandelingen.'
const WHY =
  'Een cadeaubon die niet in een la verdwijnt: de ontvanger kiest zelf of ze producten bestelt of een plek in de salon reserveert.'
const HOW = 'Je ontvangt de bon direct per mail, met een persoonlijke boodschap als je die toevoegt.'

/**
 * Digitale cadeaubonnen — in de backend gewone producten van het type 'giftcard'.
 * Btw 0: een meervoudige voucher; de btw valt pas bij inwisselen. Geen omzet bij verkoop.
 */
export const giftCards: Product[] = [
  {
    id: 'cadeaubon-50',
    kind: 'giftcard',
    name: 'Cadeaubon € 50',
    brand: 'Beauty Bewust',
    category: 'Cadeaubon',
    price: 50,
    vatRate: 0,
    volume: 'Digitaal',
    usesPerBottle: VALIDITY,
    image: IMAGE,
    skinTypes: [],
    note: NOTE,
    why: WHY,
    howTo: HOW,
    keyIngredients: [],
    rating: 0,
    reviews: 0,
    refill: false,
    pairs: [],
  },
  {
    id: 'cadeaubon-100',
    kind: 'giftcard',
    name: 'Cadeaubon € 100',
    brand: 'Beauty Bewust',
    category: 'Cadeaubon',
    price: 100,
    vatRate: 0,
    volume: 'Digitaal',
    usesPerBottle: VALIDITY,
    image: IMAGE,
    skinTypes: [],
    note: NOTE,
    why: WHY,
    howTo: HOW,
    keyIngredients: [],
    rating: 0,
    reviews: 0,
    refill: false,
    pairs: [],
  },
  {
    id: 'cadeaubon-150',
    kind: 'giftcard',
    name: 'Cadeaubon € 150',
    brand: 'Beauty Bewust',
    category: 'Cadeaubon',
    price: 150,
    vatRate: 0,
    volume: 'Digitaal',
    usesPerBottle: VALIDITY,
    image: IMAGE,
    skinTypes: [],
    note: NOTE,
    why: WHY,
    howTo: HOW,
    keyIngredients: [],
    rating: 0,
    reviews: 0,
    refill: false,
    pairs: [],
  },
]
